<template>
  <div class="app-container app-container--academy">
    <header-academy />
    <div :class="fullWidth ? false : `main-contents`">
      <slot></slot>
    </div>
    <footer-academy />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { throttle } from 'throttle-debounce'
import * as types from '@/utvStore/store/mutation-types'
import HeaderAcademy from '@/utvStore/components/Academy/partials/HeaderAcademy'
import FooterAcademy from '@/utvStore/components/Academy/partials/FooterAcademy'

export default {
  name: 'AppContainerAcademy',
  components: {
    HeaderAcademy,
    FooterAcademy,
  },
  props: {
    data: Object,
    tokenFlg: String,
    showHeader: {
      type: Boolean,
      default: true
    },
    headerLayout: {
      type: String
    },
    container: {
      type: Boolean,
      default: true
    },
    preRegist: {
      type: Boolean,
      default: false
    },
    awsPrefix: {
      type: String,
      default: ''
    },
    isDrawer: {
      type: Boolean,
      default: false
    },
    pageName: {
      type: String,
      default: ''
    },
    sessionAccessToken: {
      type: String,
      default: ''
    },
    fromChoun: {
      type: Number,
      default: 0
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['isLoggedIn']),
    ...mapState({
      accessToken: state => state.auth.accessToken,
      uiState: state => state.uiState
    })
  },
  watch:{
    uiState:{
      handler(n){
        if(this.isDrawer){
          this.bodyLock(n)
        }
      },
      deep: true
    }
  },
  mounted() {
    const mq = matchMedia('(min-width: 768px)');
    this.setDevice(mq)
    mq.addListener(this.setDevice)

    this.startWatchingScroll()
    /**
     * フロント (LocalStorage) と サーバー(Session) でのログイン状態の不整合の解消
     * tokenFlg が0(Sessionにログイン情報がない)の場合フロントのログイン情報を削除する
     **/
    if(this.fromChoun){
      //超運Dからの遷移だった場合は、ここでisLoggedIn（ログイン状態）をtrueにする
      this.$store.commit(types.SET_ACCESS_TOKEN, this.sessionAccessToken)
    }else{
      if (undefined !== typeof this.tokenFlg) {
        if (this.tokenFlg === '0' && this.isLoggedIn) {
          this.$store.dispatch(types.LOGOUT)
        } else if (this.tokenFlg == '1' && !this.isLoggedIn) {
          // storageからもトークンを消す
          this.$store.dispatch(types.LOGOUT).then(() => {
            location.href = `/user/logout`
          })
        }
      }
    }
  },
  methods: {
    startWatchingScroll: function() {
      document.addEventListener(
        'scroll',
        throttle(100, () => {
          const scrollTop =
            document.body.scrollTop || document.documentElement.scrollTop
          this.$store.commit(types.UPDATE_SCROLL_TOP, scrollTop)
        })
      )
    },
    bodyLock(uiState) {
      // bodyのスクロールを無効にする
      if(!this.uiState.isPc){
        if(uiState.showAccountModal || uiState.showDrawerMenu){
          document.body.style.overflow = 'hidden'
          document.body.style.position = 'fixed'
          document.body.style.width = '100%'
        }else{
          document.body.style.overflowX = 'hidden'
          document.body.style.overflowY = 'auto'
          document.body.style.position = 'static'
          document.body.style.width = 'auto'
        }
      }
    },
    setDevice(mq){
      this.$store.dispatch(types.IS_PC, mq.matches)
    }
  }
}
</script>

<style lang="scss" scope>
@import '../../../../../sass/commons/commonVariables.scss';

.app-container {
  font-family: roboto, arial,  "Hiragino Kaku Gothic ProN", "ヒラギノ角ゴ ProN W3", "メイリオ", Meiryo, sans-serif;
  color: $academy_text;
  min-height: 100vh;
}
.main-contents {
  max-width: 590px;
  margin: 0 auto;
  width: 100%;
  min-height: 100%;
  background: #fff;
  padding: 0 0 40px;
  overflow: hidden;
  border-bottom: 1px solid #E0E0E0;
}
</style>

<style lang="scss">
@import '../../../../../sass/commons/commonVariables.scss';

.app-container--academy {
  .form-label__label {
    color: $academy_purple !important;
  }
  .formControl,
  .form-input__input {
    border-color: $academy_purple !important;
  }
  select.formControl {
    background-image: url("/static/img/academy/arrow_down.svg");
    background-size: 14px;
  }
  .cardExpireInput,
  .confirmTerms__label {
    font-size: 13px;
  }
  .confirmTerms__checkbox {
    border-color: #D8D8D8;
    cursor: pointer;
  }
  .confirmTerms__checkbox:checked::after {
    top: -1px; left: -1px; bottom: -1px; right: -1px;
    width: 22px; height: 22px;
    background: url("/static/img/academy/check.svg") no-repeat center $academy_pink;
  }
  [name="number_payments"] {
    width: auto;
    padding-right: 36px;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Academy/partials/AppContainerAcademy.vue